// QueueActions — row of action buttons for the currently selected draft.
// Uses the existing Button primitive so styles stay consistent with the rest
// of the dashboard (Button.css variant classes).

import { Button } from "./Button";

interface Props {
  onApprove: () => void;
  onSave: () => void;
  onSnooze: () => void;
  onRegenerate: () => void;
  onSkip: () => void;
  /** Approve is disabled when commentary is empty */
  canApprove: boolean;
  /** True while an async operation (save / approve) is in flight */
  saving: boolean;
}

export function QueueActions({
  onApprove,
  onSave,
  onSnooze,
  onRegenerate,
  onSkip,
  canApprove,
  saving,
}: Props) {
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      <Button
        variant="primary"
        size="sm"
        onClick={onApprove}
        disabled={!canApprove || saving}
        title={!canApprove ? "Add commentary before approving" : undefined}
      >
        Approve &amp; Send
      </Button>

      <Button variant="secondary" size="sm" onClick={onSave} disabled={saving}>
        {saving ? "Saving…" : "Save"}
      </Button>

      <Button variant="secondary" size="sm" onClick={onSnooze} disabled={saving}>
        Snooze 24h
      </Button>

      <Button variant="secondary" size="sm" onClick={onRegenerate} disabled={saving}>
        Regenerate
      </Button>

      <Button variant="danger" size="sm" onClick={onSkip} disabled={saving}>
        Skip
      </Button>
    </div>
  );
}
